<template>
  <div>
    <div v-if="applicationStatus">
      <v-tooltip
        v-if="applicationStatus.state === 'running'"
        bottom     
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon small color="green accent-3" v-on="{ ...tooltip }"
            >fiber_manual_record</v-icon
          >
        </template>
        <span>'{{ applicationStatus.name }}' is running</span>
      </v-tooltip>

      <v-tooltip
        v-else-if="
          applicationStatus.state === 'failed' ||
          applicationStatus.state === 'exited'
        "
        bottom
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon small color="error" v-on="{ ...tooltip }"
            >fiber_manual_record</v-icon
          >
        </template>
        <span
          >'{{ applicationStatus.name }}' is not running, driver
          status: {{ applicationStatus.message }}</span
        >
      </v-tooltip>

      <v-tooltip
        v-else
        bottom
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon small color="info" v-on="{ ...tooltip }"
            >fiber_manual_record</v-icon
          >
        </template>
        <span
          >{{ applicationStatus.name }} is not running yet, driver:
          {{ applicationStatus.message }}</span
        >
      </v-tooltip>
      <span>
        {{ applicationStatus.name }}
        <v-list dense>
        <span v-for="(port, i) in getContainer(containers, applicationStatus.name).ports" :key="i" >

          
          <v-list-item dense>
            <proxy-port :device="device" :port="port"></proxy-port>
            <expose-port :application="application" :port="port" :refresh="refresh"></expose-port>           
          </v-list-item>                                              
        </span>
        </v-list>
        <br />
      </span>
    </div>
    <div v-else>
      <v-tooltip        
        bottom
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon small color="info" v-on="{ ...tooltip }"
            >fiber_manual_record</v-icon
          >
        </template>
        <span>Waiting for status</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import ProxyPort from '../cli/ProxyPort.vue';
import ExposePort from '../applications/ExposePort.vue';

export default {
  components: {
    ProxyPort,
    ExposePort
  },
  props: {
    application: Object,
    device: Object,
    containers: Array,
    applicationStatus: Object,
    refresh: Function
  },

  methods: {
    getContainer(containers, name) {
      return containers.find((c) => c.name === name)
    }
  }
}

</script>
